import {APIClient} from "../../api/httpClient";
import * as url from "./endpoints";

const api = new APIClient();

// get Waybills
export const getWaybills = (params?: {
    page?: number;
    limit?: number;
    search?: string;
    status?: string;
    date?: string;
}) => {
    let requestUrl = url.GET_WAYBILLS;
    const queryParams = new URLSearchParams();
    
    if (params?.page) queryParams.append('page', params.page.toString());
    if (params?.limit) queryParams.append('limit', params.limit.toString());
    if (params?.search) queryParams.append('search', params.search);
    if (params?.status) queryParams.append('status', params.status);
    if (params?.date) queryParams.append('date', params.date);
    
    const queryString = queryParams.toString();
    if (queryString) {
        requestUrl += `?${queryString}`;
    }
    
    return api.get(requestUrl);
};

export const getWaybillById = (id: string) => api.get(`${url.GET_WAYBILLS}/${id}`);

export const createWaybill = (data: any) => api.create(url.GET_WAYBILLS, data);

export const getWaybillFile = (accessKey: string, extension: string) =>
    api.get(`${url.GET_WAYBILL_FILE}/${accessKey}/${extension}`);

export const retryWaybillApi = (data: { progressJobId: string; progressStatus: string }) => api.create(url.RETRY_WAYBILL, data);
